import { colors } from "../colors";
import { LinkTheme } from "./types";

export const link: LinkTheme = {
    color: colors.text,
    hoverColor: colors.purple.primary,
    activeColor: colors.purple.primary,
};

